// removed by extract-text-webpack-plugin
module.exports = {"event-repeat-change-modal":"event-repeat-change-modal","prompt-question":"prompt-question","prompt-answer":"prompt-answer","prompt-answer-description":"prompt-answer-description"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/modals/component/event-repeat-change-modal/event-repeat-change-modal.style.sass
// module id = fgEq
// module chunks = 0